module.exports = __webpack_public_path__ + "static/media/collection-cover-title.fa432dbe.png";